import { REALTIME_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const CREATIVE_REALTIME_REPORT_ID = `creative${REALTIME_CAMPAIGN_SUFFIX}`;
